import React from 'react'

const Research = () => { 

    return <p>Research Goes Here</p>
}

export default Research